import { render } from "./HistoryLog.vue?vue&type=template&id=c33b0646&scoped=true"
import script from "./HistoryLog.vue?vue&type=script&lang=js"
export * from "./HistoryLog.vue?vue&type=script&lang=js"

import "./HistoryLog.vue?vue&type=style&index=0&id=c33b0646&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c33b0646"]])

export default __exports__